module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/44e4859e354c81d66c73f741df2e5ec7.svg";